module.exports = __webpack_public_path__ + "media/images/athletes/3073-7321994018ab1b9b1743845d62fb4312.png";